import PageWrapper from '@/components/PageWrapper';
import FCard from '@/components/FCard';
import FButton from '@/components/FButton';
import FPanel from '@/components/FPanel';
import FUpload from '@/components/FUpload';
import FSingleUpload from '@/components/FSingleUpload';
import FLabel from '@/components/FLabel';
import FImageView from '@/components/FImageView';
import FSingleImageView from '@/components/FSingleImageView';
import FFileSelect from '@/components/FFileSelect';
import Pagination from '@/components/Pagination';
import BatteryType from '@/components/PropsSelect/BatteryType';
import ProductType from '@/components/PropsSelect/ProductType';
import CustomerType from '@/components/PropsSelect/CustomerType';

import OrderState from '@/components/PropsSelect/OrderState';
import ReportedType from '@/components/PropsSelect/ReportedType';
import ReportedState from '@/components/PropsSelect/ReportedState';
import ModuleProducer from '@/components/PropsSelect/ModuleProducer';
import InvoiceType from '@/components/PropsSelect/InvoiceType';
import ApiState from '@/components/PropsSelect/ApiState';
// import CustomerList from '@/components/PropsSelect/CustomerList';
import EchelonUseType from '@/components/PropsSelect/EchelonUseType';
import AddressPicked from '@/components/AddressPicked';
import FSingleImageWrapper from '@/components/FSingleImageWrapper';
import CategoryStatus from '@/components/PropsSelect/CategoryStatus';
import BarCodeBatteryType from '@/components/PropsSelect/BarCodeBatteryType';
// import CategoryList from '@/components/PropsSelect/CategoryList';
import EchelonType from '@/components/PropsSelect/EchelonType';
import BooleanSelect from '@/components/PropsSelect/BooleanSelect';
import ConstituteType from '@/components/PropsSelect/ConstituteType';
// import OrderSelect from '@/components/PropsSelect/OrderSelect';
// import RecycleSite from '@/components/PropsSelect/RecycleSite';
import VueBarcode from 'vue-barcode';
import System from '@/components/System';
export default {
  install: function(Vue) {
    Vue.component('page-wrapper', PageWrapper)
    Vue.component('f-card', FCard)
    Vue.component('f-button', FButton)
    Vue.component('f-panel', FPanel)
    Vue.component('f-upload', FUpload)
    Vue.component('f-label', FLabel)
    Vue.component('f-single-upload', FSingleUpload)
    Vue.component('f-image-view', FImageView)
    Vue.component('f-single-image-view', FSingleImageView)
    Vue.component('f-single-image-wrapper', FSingleImageWrapper)
    Vue.component('pagination', Pagination)
    Vue.component('f-file-select', FFileSelect)
    Vue.component('battery-type', BatteryType)
    Vue.component('product-type', ProductType)
    // Vue.component('recycle-site', RecycleSite)
    Vue.component('customer-type', CustomerType)
    // Vue.component('customer-list', CustomerList)
    Vue.component('order-state', OrderState)
    Vue.component('reported-type', ReportedType)
    Vue.component('reported-state', ReportedState)
    // Vue.component('recycle-site', RecycleSite)

    Vue.component('module-producer', ModuleProducer)
    Vue.component('invoice-type', InvoiceType)
    Vue.component('vue-barcode', VueBarcode)
    Vue.component('api-state', ApiState)


    Vue.component('echelon-use-type', EchelonUseType)
    Vue.component("address-picked", AddressPicked)
    Vue.component("category-status", CategoryStatus)
    Vue.component("bar-code-battery-type", BarCodeBatteryType)
    // Vue.component("category-list", CategoryList)
    Vue.component("echelon-type", EchelonType)
    Vue.component("boolean-select", BooleanSelect)
    Vue.component("constitute-type", ConstituteType)
    // Vue.component("order-select", OrderSelect)
    Vue.component("system", System)
  }
}
